export class CumulativeOperatingHours {
    public hour: number = 0;
    public isCumulativeOperatingHours: boolean = false;
}